module.exports = __webpack_public_path__ + "img/magna.b629ab56.png";